import React from "react";

function LoadingIcon({ width = 80, height = 80 }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      className="lds-double-ring"
      preserveAspectRatio="xMidYMid"
      viewBox="0 0 100 100"
    >
      <circle
        cx="50"
        cy="50"
        r="25"
        fill="none"
        stroke="#ff7c81"
        strokeDasharray="39.269908169872416 39.269908169872416"
        strokeLinecap="round"
        strokeWidth="5"
        transform="rotate(360 0 0)"
      >
        <animateTransform
          attributeName="transform"
          begin="0s"
          calcMode="linear"
          dur="1s"
          keyTimes="0;1"
          repeatCount="indefinite"
          type="rotate"
          values="0 50 50;360 50 50"
        ></animateTransform>
      </circle>
      <circle
        cx="50"
        cy="50"
        r="19"
        fill="none"
        stroke="#fac090"
        strokeDasharray="29.845130209103033 29.845130209103033"
        strokeDashoffset="29.845"
        strokeLinecap="round"
        strokeWidth="5"
        transform="rotate(-360 0 0)"
      >
        <animateTransform
          attributeName="transform"
          begin="0s"
          calcMode="linear"
          dur="1s"
          keyTimes="0;1"
          repeatCount="indefinite"
          type="rotate"
          values="0 50 50;-360 50 50"
        ></animateTransform>
      </circle>
    </svg>
  );
}

export default LoadingIcon;
